"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = exports.Overlay = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const get_color_to_rgba_1 = require("../../utils/get-color-to-rgba");
const fadeInOverlay = (0, styled_components_1.keyframes) `
from {
    opacity: 0;
} to {
    opacity: 1;
}`;
const fadeOutOverlay = (0, styled_components_1.keyframes) `
from {
    opacity: 1;
} to {
    opacity: 0;
}`;
const openSidebar = (0, styled_components_1.keyframes) `
from {
    transform: translateX(100%)
} to {
    transform: translateX(0)
}`;
const closeSidebar = (0, styled_components_1.keyframes) `
from {
    transform: translateX(0)
} to {
    transform: translateX(100%)
}`;
exports.Overlay = styled_components_1.default.div `
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${(0, get_color_to_rgba_1.getColorToRGBA)("#000000", 0.2)};
  animation: ${({ isOpen }) => (isOpen ? fadeInOverlay : fadeOutOverlay)} 200ms
    ease-in-out;
`;
exports.Wrapper = styled_components_1.default.div `
  padding: 32px;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  overflow-x: hidden;
  max-height: 100vh;
  z-index: 1000;
  max-width: 400px;
  background-color: ${({ theme }) => theme.white};
  animation: ${({ isOpen }) => (isOpen ? openSidebar : closeSidebar)} 300ms
    ease-in-out;
`;
